(function () {
  'use strict';

  angular
    .module('itecAdministracio.productes.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/dades/dades.tpl.html',
            controller: 'ProductesMainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());
